import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyClassAvatars: BaseKeyFunction = () => ["class-avatars"];
